module.exports = __webpack_public_path__ + "static/img_xnzf.a74ca67f.png";